import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-navy-ink text-white blueprint-grid" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid gap-12 md:grid-cols-2">
        <div>
          <div className="bg-white inline-block px-4 py-3 mb-6">
            <img src="/assets/builderedu-logo.png" alt="BuilderEDU" className="h-10 w-auto" />
          </div>
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            Real-world residential construction experience for high school students.
          </p>
        </div>
        <div className="md:justify-self-end">
          <p className="font-head text-xs font-bold uppercase tracking-[0.2em] text-brand mb-5">Navigate</p>
          <div className="flex flex-col gap-3">
            <Link to="/" data-testid="footer-home-link" className="text-white/70 hover:text-brand transition-colors text-sm">Home</Link>
            <Link to="/what-builderedu-does" data-testid="footer-what-link" className="text-white/70 hover:text-brand transition-colors text-sm">What BuilderEDU Does</Link>
            <Link to="/blueprint-for-success" data-testid="footer-blueprint-link" className="text-white/70 hover:text-brand transition-colors text-sm">Blueprint for Success</Link>
            <Link to="/connect" data-testid="footer-connect-link" className="text-white/70 hover:text-brand transition-colors text-sm">Connect</Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-white/40">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} BuilderEDU. All rights reserved.</span>
          <Link to="/admin" data-testid="footer-admin-link" className="hover:text-brand transition-colors">Admin</Link>
        </div>
      </div>
    </footer>
  );
}
